module.exports = __webpack_public_path__ + "images/ddzfk.png?2ddd0531d8482b362da8541b70d6220e";


//////////////////
// WEBPACK FOOTER
// ./src/images/ddzfk.png
// module id = 219
// module chunks = 1